<template>
    <div class="default_list_bor">
        <p v-if="loading" style="width:100%;height:3rem;line-height:3rem;text-align:center"> <mt-spinner type="triple-bounce"></mt-spinner> </p>
        <div v-if="!loading" v-for="(item,index) in  shufflingFunList" :key="item.id" @click="shufflingPicFun(item)">
            <div v-if="item.image_url != ''" class="default_list_app">
                <p class="app_list_title">{{item.title}}</p>
                <div class="app_list_if app_list_img">
                    <div class="app_list_if_img">
                        <img :src="item.image_url" alt="">
                    </div>
                    <p class="all_text_if_imgs" v-for="item in abstractContent" v-if="index == item.id" :key="item.id">{{item.content}}</p>
                </div>
            </div>

            <div v-if="item.image_url == ''" class="default_list_app">
                <p class="app_list_title">{{item.title}}</p>
                <div class="app_list_if">
                    <p class="all_text_if_img" v-for="item in abstractContent" v-if="index == item.id" :key="item.id">{{item.content}}</p>
                </div>
            </div>
        </div>
        

        <div class="view_morm_btn">
            <p class="view_morm_app" @click="checkDetails('5287fdce-892d-4eb0-a147-5047637fdd7c')">查看更多 »</p>
        </div>
    </div>
</template>
<script>
import { listApi, listDetails, generateSign } from '@/api/index'
// 濮阳新闻
const shufflingParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5287fdce-892d-4eb0-a147-5047637fdd7c",
    userId: "",
    appInfoId: "10"
}
const shufflingAbstract = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}
export default {
    data(){
        return {
            loading:true,
            shufflingFunListOne:null,
            // 濮阳新闻
            shuParameter: Object.assign({}, shufflingParameter),
            // shufflingAbstractOne: Object.assign({}, shufflingAbstract),
            shufflingFunList:null,
            shufflingFunListOne:null,
            abstractContent:[],
        }
    },
    created(){
        this.shufflingFuns()
    },
    methods:{
        checkDetails(uuid){
            this.$router.push({path:'/detailsList', query: {  id: uuid , titleName : '手机报' , typeNum : 1}})
        },
        // listDetails(){
        //     this.$router.replace('/listDetailsApp')
        // },
         // 濮阳新闻
        async shufflingFuns(){
const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(listApi,this.shuParameter,{ headers })
            this.shufflingFunList = res.data.data[0].list.splice(0,5)
            this.newsLists()
        },
        newsLists(){
const headers = { 
        'Sign': generateSign()
      };
            this.abstractContent = []
            this.shufflingFunList.forEach((item,index) => {
                let listNews = {};
                let shufflingAbstractOne = {
                    type: 1,
                    id: item.id,
                    userId: "",
                    appInfoId: "10"
                }
                listNews['id'] = index

                this.axios.post(listDetails,shufflingAbstractOne,{ headers }).then(res => {
                    listNews['content'] = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                    this.abstractContent.push(listNews)
                    this.loading = false
                })
            });
        },
        shufflingPicFun(type){
            this.$router.push({path:'/listDetailsApp', query: {  id: type.id,jsonUrl:type.jsonUrl , typeNum : 1,url:type.url}})
        }
    }
}
</script>
<style lang="">
    .default_list_bor{
        margin:0 0.8rem;
        border-top:0.05rem solid #DCDCDC;
    }
    .default_list_app{
        border-bottom:0.08rem  dashed #DCDCDC;
        padding:.6rem 0.4rem 1.2rem 0.4rem;
    }
    .app_list_title{
        padding: 0.4rem 0;
        font-size:1.2rem;    
        font-family: Source Han Sans CN;
        color: #333333;
    }
  
    .app_list_img{
        height: 4.5rem;
    }
    .app_list_if .app_list_if_img{
        width:6rem;
        height:4.5rem;
        float: left;
        padding-right: 0.8rem;
    }
    .app_list_if .app_list_if_img img{
        width:100%;
        height:100%;
        display: block;
        border-radius: 0.2rem;
    }
    .app_list_if .all_text_if_img{
        line-height: 1.1rem;
        font-size:0.8rem;
        color:#646464;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .app_list_if .all_text_if_imgs{
        line-height: 1.1rem;
        font-size:0.8rem;
        color:#646464;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
    }
    .app_list_if .all_text{
        line-height: 1rem;
        font-size:0.6rem;
        color:#646464;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .view_morm_btn{
        margin:0.6rem 0;
        height:2rem;
        background: #efefef;
        border:0.05rem solid #DCDCDC;
        text-align: center;
        line-height:2rem;
    }
    .view_morm_btn .view_morm_app{
        font-size: 1.2rem;
        color:#C90304;
    }
</style>


// WEBPACK FOOTER //
// src/components/appModule/homePageAppThree/appContentLista/index.vue